/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';

const MIN_PERCENTAGE = 0;
const MAX_PERCENTAGE = 100;

class VerbCircularProgressbar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            percentage: props.initialAnimation ? 0 : props.percentage
        };
    }

    componentDidMount() {
        if (this.props.initialAnimation) {
            this.initialTimeout = setTimeout(() => {
                this.requestAnimationFrame = window.requestAnimationFrame(() => {
                    this.setState({
                        percentage: this.props.percentage
                    });
                });
            }, 0);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            percentage: nextProps.percentage
        });
    }

    componentWillUnmount() {
        clearTimeout(this.initialTimeout);
        if (window && window.cancelAnimationFrame) {
            window.cancelAnimationFrame(this.requestAnimationFrame);
        }
    }

    getPathDescription() {
        const radius = this.getRadius();
        return `
      M 50,50 m 0,-${radius}
      a ${radius},${radius} 0 1 1 0,${2 * radius}
      a ${radius},${radius} 0 1 1 0,-${2 * radius}
    `;
    }

    getProgressStyle() {
        const diameter = Math.PI * 2 * this.getRadius();
        const truncatedPercentage = Math.min(Math.max(this.state.percentage, MIN_PERCENTAGE), MAX_PERCENTAGE);
        return {
            strokeDasharray: `${diameter}px ${diameter}px`,
            strokeDashoffset: `${((100 - truncatedPercentage) / 100) * diameter}px`
        };
    }

    getRadius() {
        return 50 - this.props.strokeWidth / 2;
    }

    render() {
        const { percentage, textForPercentage, className, strokeWidth, imageForPercentage } = this.props;
        const classForPercentage = this.props.classForPercentage ? this.props.classForPercentage(percentage) : '';
        const pathDescription = this.getPathDescription();

        const text = textForPercentage ? textForPercentage(percentage) : null;
        const image = imageForPercentage();

        return (
            <svg className={`CircularProgressbar ${className} ${classForPercentage}`} viewBox={'0 0 100 100'}>
                <path
                    className={'CircularProgressbar-trail'}
                    d={pathDescription}
                    strokeWidth={strokeWidth}
                    fillOpacity={0}
                />

                <path
                    className={'CircularProgressbar-path'}
                    d={pathDescription}
                    strokeWidth={strokeWidth}
                    fillOpacity={0}
                    style={this.getProgressStyle()}
                />

                {text ? (
                    <text className={'CircularProgressbar-text'} x={50} y={50}>
                        {text}
                    </text>
                ) : (
                    image
                )}
            </svg>
        );
    }
}

VerbCircularProgressbar.propTypes = {
    percentage: PropTypes.number.isRequired,
    strokeWidth: PropTypes.number,
    className: PropTypes.string,
    initialAnimation: PropTypes.bool,
    classForPercentage: PropTypes.func,
    textForPercentage: PropTypes.func,
    imageForPercentage: PropTypes.func
};

VerbCircularProgressbar.defaultProps = {
    strokeWidth: 8,
    className: '',
    initialAnimation: false,
    textForPercentage: (percentage) => `${percentage}%`,
    imageForPercentage: () => null
};

export default VerbCircularProgressbar;
